<template>
    <div :class="[
        'component',
        'component__text_list',
        color ? `component__text_list--${color}` : '',
        size ? `component__text_list--${size}` : ''
    ]">
        <div v-if="title" class="component__text_list_title">{{ title }}</div>
        <ul>
            <template v-if="outputItems ? outputItems.length : false">
                <li
                    v-for="(item, index) in outputItems"
                    :key="index"
                >{{ item }}
                </li>
            </template>
            <template v-if="htmlItems ? htmlItems.length : false">
                <li
                    v-for="(item, index) in htmlItems"
                    v-html="item"
                    :key="index"
                ></li>
            </template>
        </ul>
        <component-button
            v-if="limitActive && items && items.length > limitItems"
            :name="'component-text-list-readmore-button'"
            :text="true"
            :underline="true"
            :size="'normal'"
            @click="switchReadMore"
        >{{ listExpanded ? `- ${items.length - limitItems} less` : `+ ${items.length - limitItems} more` }}
        </component-button>
    </div>
</template>

<script>
export default {
  name: 'component-text-list',
  components: {
    ComponentButton: () => import('@/components/default/shared/ComponentButton')
  },
  data () {
    return {
      listExpanded: false
    }
  },
  props: {
    title: {
      type: String
    },
    items: {
      type: Array
    },
    htmlItems: {
      type: Array
    },
    limitActive: {
      type: Boolean,
      default: false
    },
    limitItems: {
      type: Number,
      default: 3
    },
    color: {
      type: String
    },
    size: {
      type: String
    }
  },
  computed: {
    outputItems () {
      let itemsArr = this.items ? JSON.parse(JSON.stringify(this.items)) : []

      if (this.limitActive && !this.listExpanded && itemsArr.length > this.limitItems) {
        itemsArr.length = this.limitItems
      }

      return itemsArr
    }
  },
  methods: {
    switchReadMore () {
      this.listExpanded = !this.listExpanded
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/default/shared/componenttextlist";
</style>
